import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import NavBar from "./components/navbar";
import Header from "./components/header";
import Footer from "./components/footer";
import NotFound from "./components/notFound";
import Main from "./components/main";
import Main2 from "./components/main2";
import Language from "./components/language";
import Language2 from "./components/language2";
import Reason from "./components/reason";
import Generalregistration from "./components/generalregistration";
import Generalregistration2 from "./components/generalregistrationtwo";
import WardVisitor from "./components/wardvisitor";
import Wardregistration from "./components/wardregistration";
import Wardregistration2 from "./components/wardregistration2";
import SuccessReg from "./components/successreg";
import SuccessReg2 from "./components/successreg2";
import Quotafull from "./components/quotafull";
import Accessdenied from "./components/accessdenied";
import EmergencyAlert from "./components/emergencyalert";
import LaneClosed from "./components/laneclosed";
import Exceeded from "./components/exceeded";
import PatientAway from "./components/patientaway";
import WardSummary from "./components/wardsummary";
import WardSummary2 from "./components/wardsummary2";
import GeneralSummary from "./components/generalsummary";
import Apptregistration from "./components/apptregistration";
import ApptSummary from "./components/apptsummary";
import WardRegExist from "./components/wardregexist";
import GeneralQuestion from "./components/generalquestion";
import GeneralQuestionTwo from "./components/generalquestiontwo";

import Keyboard from "./components/common/keyboard";

import "./App.css";
import "./styles/animation.css";
import "./styles/custom.css";
import 'bootstrap/dist/css/bootstrap.min.css';


class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show: false,
      showPopup: false
    };

    this.toggleDiv = this.toggleDiv.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
  }

  togglePopup = () => {
    const { showPopup } = this.state;
    this.setState({ showPopup: !showPopup })
  }


  toggleDiv = () => {
    const { show } = this.state;
    this.setState({ show: !show })
  }


  render() {
    return (
      <React.Fragment>

        <div className="toggle">
          <button onClick={this.toggleDiv}>Hide/Show-Navigation</button>
          <button onClick={this.togglePopup} className="keyboardButtonPop"> Show Keyboard </button>
        </div>


        

        {/* KEYBOARD POP UP  */}
        {this.state.showPopup && <Keyboard />}

        <Header />


        <main className="containerBox">
          <div className="contentBox">
            <Switch>
              {/* <Route path="/keyboard" component={Keyboard} /> */}
              <Route path="/generalquestiontwo" component={GeneralQuestionTwo} />
              <Route path="/generalquestion" component={GeneralQuestion} />
              <Route path="/wardregexist" component={WardRegExist} />
              <Route path="/apptsummary" component={ApptSummary} />
              <Route path="/apptregistration" component={Apptregistration} />
              <Route path="/generalsummary" component={GeneralSummary} />
              <Route path="/wardsummary" component={WardSummary} />
              <Route path="/wardsummary2" component={WardSummary2} />
              <Route path="/patientaway" component={PatientAway} />
              <Route path="/exceeded" component={Exceeded} />
              <Route path="/laneclosed" component={LaneClosed} />
              <Route path="/emergencyalert" component={EmergencyAlert} />
              <Route path="/accessdenied" component={Accessdenied} />
              <Route path="/quotafull" component={Quotafull} />
              <Route path="/successreg" component={SuccessReg} />
              <Route path="/successreg2" component={SuccessReg2} />
              <Route path="/wardregistration" component={Wardregistration} />
              <Route path="/wardregistration2" component={Wardregistration2} />
              <Route path="/generalregistration" component={Generalregistration} />
              <Route path="/generalregistrationtwo" component={Generalregistration2} />
              <Route path="/wardvisitor" component={WardVisitor} />
              <Route path="/reason" component={Reason} />
              <Route path="/language2" component={Language2} />
              <Route path="/language" component={Language} />
              <Route path="/main" component={Main} />
              <Route path="/main2" component={Main2} />
              <Route path="/not-found" component={NotFound} />
              <Redirect from="/" exact to="/main" />
              <Redirect to="/not-found" />
            </Switch>
          </div>
        </main>

        <Footer />

        {/* TOGGLE SHOW  */}
        {this.state.show && <NavBar />}


      </React.Fragment>
    );
  }
}

export default App;